import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export enum DiscountTypesEnum {
  no_discount = 'no_discount',
  amount = 'amount',
  percentage = 'percentage',
}

export const DEFAULT_DISCOUNT_TYPE = DiscountTypesEnum.no_discount;

export const DISCOUNT_SCHEMA = Object.freeze({
  TYPE: DEFAULT_DISCOUNT_TYPE,
  PERCENTAGE: 0,
  AMOUNT: 0,
});
const RECORD = generateSchema(DISCOUNT_SCHEMA);
const KEYS: any = generateKeys(DISCOUNT_SCHEMA);

export class Discount extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get type(): string {
    return this.get(KEYS.TYPE);
  }

  get percentage(): number {
    return this.get(KEYS.PERCENTAGE);
  }

  get amount(): number {
    return this.get(KEYS.AMOUNT);
  }

  isNoDiscount(): boolean {
    return this.type === DiscountTypesEnum.no_discount;
  }

  isAmountType(): boolean {
    return this.type === DiscountTypesEnum.amount;
  }

  isPercentageType(): boolean {
    return this.type === DiscountTypesEnum.percentage;
  }
}
